(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    // a simple wrapper on Firebase and AngularFire to simplify deps and keep things DRY
    ngModule.factory('fbutil', ['$window', '$q', 'fbUrl', function($window, $q, FBURL) {

        var utils = {
            // convert a node or Firebase style callback to a future
            handler: function(fn, context) {
                return utils.defer(function(def) {
                    fn.call(context, function(err, result) {
                        if( err !== null ) { def.reject(err); }
                        else { def.resolve(result); }
                    });
                });
            },

            // abstract the process of creating a future/promise
            defer: function(fn, context) {
                var def = $q.defer();
                fn.call(context, def);
                return def.promise;
            },

            ref: firebaseRef
        };

        return utils;

        function pathRef(args) {
            for (var i = 0; i < args.length; i++) {
                if (angular.isArray(args[i])) {
                    args[i] = pathRef(args[i]);
                }
                else if( typeof args[i] !== 'string' ) {
                    throw new Error('Argument '+i+' to firebaseRef is not a string: '+args[i]);
                }
            }
            return args.join('/');
        }

        /**
        * Example:
        * <code>
        *    function(firebaseRef) {
        *       var ref = firebaseRef('path/to/data');
        *    }
        * </code>
        *
        * @function
        * @name firebaseRef
        * @param {String|Array...} path relative path to the root folder in Firebase instance
        * @return a Firebase instance
        */
        function firebaseRef(path) {
            var ref = new $window.Firebase(FBURL);
            var args = Array.prototype.slice.call(arguments);
            if( args.length ) {
                ref = ref.child(pathRef(args));
            }
            return ref;
        }
    }]);

    ngModule.controller('LoginCtrl', ['$rootScope', '$scope', 'Auth', '$location', 'fbutil', '$state', function($rootScope, $scope, Auth, $location, fbutil, $state) {

        $scope.email = null;
        $scope.pass = null;
        $scope.confirm = null;
        $scope.createMode = false;

        angular.element('.loginBtn').trigger('focus');

        $scope.login = function(email, pass) {
            $scope.err = null;
            firebase.auth().signInWithEmailAndPassword(email, pass)
            .then(function( user /* user */) {
                console.log('user', user);
                // $state.go('home');
                $state.go('stores');
                // $rootScope.hasLogin = user;
            }, function(err) {
                $scope.err = errMessage(err);
            });
        };

        $scope.createAccount = function() {
            $scope.err = null;
            if( assertValidAccountProps() ) {
                var email = $scope.email;
                var pass = $scope.pass;
                // create user credentials in Firebase auth system
                Auth.$createUser({email: email, password: pass})
                .then(function() {
                    // authenticate so we have permission to write to Firebase
                    return firebase.auth().signInWithEmailAndPassword(email, pass);
                })
                .then(function(user) {
                    // create a user profile in our data store
                    var ref = fbutil.ref('users', user.uid);
                    return fbutil.handler(function(cb) {
                        ref.set({email: email, name: name||firstPartOfEmail(email)}, cb);
                    });
                })
                .then(function(/* user */) {
                    // redirect to the account page
                    $location.path('/home');
                }, function(err) {
                    $scope.err = errMessage(err);
                });
            }
        };

        function assertValidAccountProps() {
            if( !$scope.email ) {
                $scope.err = 'Please enter an email address';
            }
            else if( !$scope.pass || !$scope.confirm ) {
                $scope.err = 'Please enter a password';
            }
            else if( $scope.createMode && $scope.pass !== $scope.confirm ) {
                $scope.err = 'Passwords do not match';
            }
            return !$scope.err;
        }

        function errMessage(err) {
            return angular.isObject(err) && err.code? err.code : err + '';
        }

        function firstPartOfEmail(email) {
            return ucfirst(email.substr(0, email.indexOf('@'))||'');
        }

        function ucfirst (str) {
            // inspired by: http://kevin.vanzonneveld.net
            str += '';
            var f = str.charAt(0).toUpperCase();
            return f + str.substr(1);
        }
    }]);
})();
